module.exports = __webpack_public_path__ + "static/media/tot_prv_cpt-grey.15bb8bfb.svg";